import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL_NEW } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import { TagListResponse } from '@utils/types/organization/tag.ts';
import { PagedListParams } from '@utils/api/endpoints.paged.ts.tsx';

export const useGetTags = (params?: PagedListParams) => {
  const fetchTags = async (): Promise<TagListResponse> => {
    const url = GET_URL_NEW(params).tags;
    const { data } = await Axios.get<TagListResponse>(url);
    return data;
  };

  const offset =
    typeof params?.offset === 'string' ? Number(params.offset) : params?.offset;
  const limit =
    typeof params?.limit === 'string' ? Number(params.limit) : params?.limit;
  const q = Array.isArray(params?.q) ? params?.q.join(',') : params?.q;

  return useQuery(
    QueryKeys.tags(offset, limit, q, params?.sort, params?.direction),
    fetchTags
  );
};
